// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2u7Dz","title":"ClientInsurance_title__1uuZz","itemText":"ClientInsurance_itemText__hSg4G"};